import { AdvertiserAccount } from '@synapex/shared2/gateway-rest-api';

import { parseDateField } from '../../../utils';

type AllReply = AdvertiserAccount.AllReply;
type CreatedReply = AdvertiserAccount.CreatedReply;

////////////////////parts

const activeUser = (data: AllReply['user']) => {
  parseDateField(data, 'created_at');

  return data;
};

const oad = (
  data: NonNullable<
    AllReply['advertiserAccounts'][number]['ordAdditionalData']
  >,
) => {
  return data;
};

const googleDriveConnection = (
  data: NonNullable<
    AllReply['advertiserAccounts'][number]['googleDriveConnection']
  >,
) => {
  // parseDateField(data, 'created_at');
  // parseDateField(data, 'updated_at');

  return data;
};

const permission = (
  data: AllReply['advertiserAccounts'][number]['permission'],
) => {
  return data;
};

export const workspace = (
  data: AllReply['advertiserAccounts'][number]['workspaces'][number],
) => {
  parseDateField(data, 'created_at');

  return data;
};

export const site = (
  data: Extract<
    AllReply['advertiserAccounts'][number]['workspaces'][number],
    { workspace_type: 'site' }
  >,
) => {
  workspace(data);

  return data;
};

export const channel = (
  data: Extract<
    AllReply['advertiserAccounts'][number]['workspaces'][number],
    { workspace_type: 'channel' }
  >,
) => {
  workspace(data);

  return data;
};

export const existentAccountChannelRequest = (
  data: AllReply['advertiserAccounts'][number]['channelRequests'][number],
) => {
  parseDateField(data, 'created_at');

  return data;
};

export const newAccountChannelRequest = (
  data: AllReply['channelRequests'][number],
) => {
  parseDateField(data, 'created_at');

  return data;
};

export const advertiserAccount = (
  data: AllReply['advertiserAccounts'][number],
) => {
  parseDateField(data, 'created_at');
  parseDateField(data, 'updated_at');

  for (const ws of data.workspaces) {
    workspace(ws);
  }

  for (const cr of data.channelRequests) {
    existentAccountChannelRequest(cr);
  }

  if (data.ordAdditionalData) {
    oad(data.ordAdditionalData);
  }

  if (data.googleDriveConnection) {
    googleDriveConnection(data.googleDriveConnection);
  }

  permission(data.permission);

  return data;
};

const workspaceWithOrdData = (data: AllReply['workspaces'][number]) => {
  parseDateField(data, 'created_at');

  if (data.ordAdditionalData) {
    oad(data.ordAdditionalData);
  }

  if (data.googleDriveConnection) {
    googleDriveConnection(data.googleDriveConnection);
  }

  permission(data.permission);

  return data;
};

////////////////////replies

export const allReply = (data: AllReply) => {
  activeUser(data.user);
  for (const acc of data.advertiserAccounts) {
    advertiserAccount(acc);
  }
  for (const ws of data.workspaces) {
    workspaceWithOrdData(ws);
  }

  for (const cr of data.channelRequests) {
    newAccountChannelRequest(cr);
  }

  return data;
};

export const createdReply = (data: CreatedReply) => {
  advertiserAccount(data);

  return data;
};
